import React from "react";
import {
  Box,
  Stack,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  DialogContentText,
  FormControlLabel,
} from "@mui/material";
import {
  Close,
  Info,
  KeyboardArrowDown,
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardArrowUp,
  KeyboardDoubleArrowDown,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  KeyboardDoubleArrowUp,
  Save,
} from "@mui/icons-material";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import CloseButton from "../../../components/commonComponents/Buttons/CloseButton";
import { useDispatch, useSelector } from "react-redux";
import DualListBox from "react-dual-listbox";
import {
  HtmlTooltip,
  StyledBlackInformationTypography,
  StyledCheckbox,
  StyledDarkRedInformationTypography,
  StyledMainBox,
  StyledSwitch,
} from "../../../components/commonComponents/StyledComponents/styled";
import PropTypes from "prop-types";
import NewReportSection from "./NewReportSection";
import EditReportSection from "./EditReportSection";
import {
  clearSectionsList,
  fetchReportSettings,
  resetEditSectionDetails,
  resetReportSettings,
  saveVisibleSectionsForCampaign,
} from "../../../api_calls/ReportSettings";
import { updateStateData } from "../../../Store/actions";
import { DisabledGreyButton } from "../../../components/commonComponents/Buttons/DisabledButton";
import ReportPreview from "./Previews/ReportPreview";
import { toast } from "react-toastify";
import { fetchCampaign } from "../../../api_calls/campaignRequests";
import { checkUserRole } from "../../../api_calls/userManagement";

// to load tab content
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ReportSectionSettings = ({ open, size, closeModal, campaignRecord }) => {
  const currentStateData = useSelector((state) => state.userSelections);
  const [showNewSection, setShowNewSection] = React.useState(false);
  const [showEditSection, setShowEditSection] = React.useState(false);
  const dispatchAction = useDispatch();
  const reportPublishStatus = typeof currentStateData.report_settings !== "undefined" && typeof currentStateData.report_settings.published !== "undefined" ? currentStateData.report_settings.published : false
  const userRole = checkUserRole();
  // const reportAvailableFlag = [4].includes(campaignRecord.campaign_status_code) ? true : false;
  const [reportAvailable, setReportAvailable] = React.useState(reportPublishStatus);
  const [markDefault, setMarkDefault] = React.useState(false);
  const [showPreview, setShowPreview] = React.useState(false);
  const impressionNotAvailable = typeof currentStateData.report_section_availability !== "undefined" && currentStateData.report_section_availability.impression_section === false ? true : false;
  
  // typeof currentStateData.workspace_report_sections !== "undefined" && currentStateData.workspace_report_sections !== null && currentStateData.workspace_report_sections.length > 0 ? currentStateData.workspace_report_sections.filter(sec => sec.type === "impression").length === 0 : true;

  const setSelectedOptions = (selectedOptions) => {
    dispatchAction(
      updateStateData({
        report_settings: {
          ...currentStateData.report_settings,
          visible_options: [...selectedOptions],
        },
      })
    );
  };

  React.useEffect(() => {
    // fetchReportSettings(campaignRecord.campaign_id).then(info => {
    //   setReportAvailable(reportPublishStatus);
    // })
  }, []);

  return (
    <>
      <Dialog
        open={open}
        onClose={(e) => {
          e.preventDefault();
        }}
        fullWidth={true}
        maxWidth={size}
      >
        <DialogTitle>
          <strong>Report Settings</strong>
        </DialogTitle>
        <DialogContent>
          {/* ------- disclaimer text for brand report --------- */}
          <DialogContentText>
            <Stack direction={"row"} spacing={3}>
              {/* ------ cyreen store id ------ */}
              <Box>
                <Stack direction={"row"} spacing={1}>
                  <StyledDarkRedInformationTypography>Campaign Name :</StyledDarkRedInformationTypography>
                  <StyledBlackInformationTypography>{campaignRecord.campaign_name}</StyledBlackInformationTypography>
                </Stack>
              </Box>
              <Box>
                <Stack direction={"row"} spacing={1}>
                  <StyledDarkRedInformationTypography>Campaign ID :</StyledDarkRedInformationTypography>
                  <StyledBlackInformationTypography>{campaignRecord.campaign_id}</StyledBlackInformationTypography>
                </Stack>
              </Box>
            </Stack>
            {
              impressionNotAvailable === true && (
                <>
                  <Box height={30} />
                  <Stack direction={"row"} spacing={3}>
                    {/* ------ warning text when impressions aren't yet added ------ */}
                    <Box>
                      <StyledDarkRedInformationTypography variant="body2">
                        Warning: Not all companies in this tenant have an impressions section configured. Automated publishing of impressions reports is disabled for some campaigns.
                      </StyledDarkRedInformationTypography>
                    </Box>
                  </Stack>
                </>
              )
            }

          </DialogContentText>
          <Box height={30} />
          <Box>
            <Typography variant="body3">
              <strong>Report Visibility </strong>
            </Typography>

            <Box height={5} />
            <Typography variant="body2">
              Move sections to the ‘Visible Sections’ box to display them in the brand report. The 'Impressions' section is always added to the visible section automatically. It cannot be removed and is only included for informational purposes. If no Impressions section is shown, please adjust the workspace section settings.
            </Typography>
            <Box height={10} />
            <Typography variant="body2">
              Their order here determines their position in the report - top to bottom equals left to right in the report.
            </Typography>

            <Box height={20} />
            <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
              <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
                <Typography variant="body2" sx={{ marginRight: "60px" }}>
                  <strong>Available Sections</strong>
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
                <Typography variant="body2" sx={{ marginRight: "60px" }}>
                  <strong>Visible Sections</strong>
                </Typography>
              </Box>
            </Box>
            <Box height={10} />
            <DualListBox
              id="reportSectionsListBox"
              preserveSelectOrder={true}
              showOrderButtons={true}
              options={
                typeof currentStateData.report_settings !== "undefined" &&
                  typeof currentStateData.report_settings.available_options !== "undefined"
                  ? currentStateData.report_settings.available_options
                    .map((availableOption) => {
                      return {
                        value: availableOption.id,
                        label: availableOption.name + " - (" + availableOption.description + ")" + " - (" + availableOption.id_embeddable + ")",
                      };
                    })
                    .sort((next, prev) => {
                      return next.label.localeCompare(prev.label);
                    })
                  : []
              }
              className={impressionNotAvailable === true ? "dualListForSections" : "dualListForSections highlightImpressionForReportSections"}
              selected={
                typeof currentStateData.report_settings !== "undefined" &&
                  typeof currentStateData.report_settings.visible_options !== "undefined"
                  ? Array.from(
                    new Set([
                      ...currentStateData.report_settings.available_options
                        .filter(sec => sec.type === "impression")
                        .map(section => section.id),
                      ...currentStateData.report_settings.visible_options
                    ])
                  )
                  : []
              }
              onChange={(newValue) => {
                setSelectedOptions(newValue);
              }}
              icons={{
                moveToAvailable: <KeyboardArrowLeft />,
                moveAllToAvailable: <KeyboardDoubleArrowLeft />,
                moveToSelected: <KeyboardArrowRight />,
                moveAllToSelected: <KeyboardDoubleArrowRight />,
                moveDown: <KeyboardArrowDown />,
                moveUp: <KeyboardArrowUp />,
                moveTop: <KeyboardDoubleArrowUp />,
                moveBottom: <KeyboardDoubleArrowDown />,
              }}
            />
          </Box>
          {/* ----------- preview report button and make default checkbox ----------- */}
          <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
            <Box display="flex" alignItems="center">
              <ActionButton
                onClick={(e) => {
                  e.preventDefault();
                  fetchCampaign(campaignRecord.campaign_id, "all", userRole.user_role, "preview").then(() => {
                    setShowPreview(true);
                  });
                }}
                label={"Preview Report"}
                icon={<></>}
              />
            </Box>
            <Box>
              <Box ml={12}>
                {/* Add margin between the buttons */}
                <FormControlLabel
                  control={
                    <StyledCheckbox
                      checked={typeof currentStateData.report_settings !== "undefined" &&
                        typeof currentStateData.report_settings.marked_as_default !== "undefined"
                        ? currentStateData.report_settings.marked_as_default : markDefault}
                      onChange={(e) => {
                        setMarkDefault(!markDefault);
                        dispatchAction(
                          updateStateData({
                            report_settings: {
                              ...currentStateData.report_settings,
                              marked_as_default: !markDefault,
                            },
                          })
                        );
                      }}
                    />
                  }
                  label="Make Default"
                />
              </Box>
            </Box>
          </Box>

          <Box height={5} />
          <Box>
            <Typography variant="body2">
              Preview the report before publishing it to the customer. The preview reflects the current settings in this window, regardless of any previously saved versions. Once ready, publish the report which automatically notifies the customer that a new report is available.
            </Typography>
            <Box height={15} />
            <Typography variant="body3">
              <strong>Publish Report</strong>
            </Typography>
            <Box height={5} />

            {/*  old default value: ![2, 4].includes(campaignRecord.campaign_status_code) ? true : false */}
            <FormControlLabel
              control={
                <StyledSwitch
                  id="campaignReportAvailableSwitch"
                  checked={reportAvailable}
                  disabled={![2, 4].includes(campaignRecord.campaign_status_code) ? true : false}
                  onChange={(e) => {
                    setReportAvailable(!reportAvailable);
                    dispatchAction(
                      updateStateData({
                        report_settings: {
                          ...currentStateData.report_settings,
                          published: !reportAvailable,
                          report_status_updated: true,
                        },
                      })
                    );
                  }}
                />
              }
              label={"Report Published"}
              sx={{ minWidth: 100 }}
            />
          </Box>
        </DialogContent>

        <Box height={20} />
        <DialogActions>
          <Stack direction={"row"} spacing={2}>
            <CloseButton
              onClick={(e) => {
                e.preventDefault();
                resetReportSettings();
                resetEditSectionDetails();
                closeModal();
              }}
              label="Cancel"
              icon={<Close />}
            />

            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                // atleast one section must be selected (if report status set to publish)
                if (typeof currentStateData.report_settings !== "undefined" &&
                  typeof currentStateData.report_settings.visible_options !== "undefined" && typeof currentStateData.report_settings.published !== "undefined" && currentStateData.report_settings.published === true && currentStateData.report_settings.visible_options.length === 0) {
                  toast("Please select report sections before publishing the report.", { "type": "error" })
                } else {
                  saveVisibleSectionsForCampaign(campaignRecord.campaign_id).then((info) => {
                    if (info.success === true) {
                      closeModal();
                    }
                  });
                }

              }}
              label={"Save"}
              icon={<Save />}
            />
          </Stack>
        </DialogActions>
      </Dialog>
      {/* ------------- new section popup ----------- */}
      {showNewSection === true && (
        <NewReportSection
          showModal={showNewSection}
          closeModal={setShowNewSection}
          campaignId={campaignRecord.campaign_id}
        />
      )}

      {/* ------------ edit section popup ------------ */}
      {showEditSection === true && (
        <EditReportSection
          showModal={showEditSection}
          closeModal={setShowEditSection}
          campaignId={campaignRecord.campaign_id}
        />
      )}

      {/* -------- dashboard preview ----------- */}
      {
        showPreview === true && (
          <ReportPreview
            showModal={showPreview}
            closeModal={() => {
              setShowPreview(false);
            }}
            campaignId={campaignRecord.campaign_id}
          />
        )
      }
    </>
  );
};

export default ReportSectionSettings;
